<template>
  <div class="j-upload-layout-wrap">
    <div class="j-upload-style-tip-slot"><slot name="tip-top" /></div>
    <div :class="['j-upload-layout', mode]">
      <el-upload ref="JUploadRef"
                 :class="['j-upload-style', mode, drag ? 'j-upload-drag' : '']"
                 useOss
                 v-bind="$attrs"
                 v-if="!readOnly"
                 v-show="fileList.length < countLimit"
                 :limit="countLimit - fileList.length"
                 :action="action"
                 :data="postData"
                 :drag="drag"
                 :accept="fileSuffixLimit.length > 0 ? '' : mimeTypeLimit.join(',')"
                 :before-upload="handleCheck"
                 :on-progress="handleProgress"
                 :on-exceed="handleExceed"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :show-file-list="false"
      >
        <!--拖拽上传时样式、插槽形势特殊处理-->
        <template v-if="drag">
          <div class="j-upload-style-drag"><span>点击上传</span>或将文件拖拽到此区域</div>
          <slot />
          <div class="j-upload-style-tip-slot"><slot name="tip" /></div>
        </template>
        <!--除拖拽上传时默认样式和插槽-->
        <template v-else>
          <template v-if="!$slots.default || $slots.default.length === 0">
            <el-button v-if="mode === 'list'" type="text">{{ buttonText || '上传' }}</el-button>
            <div v-else :class="['j-upload-style-slot', 'j-file-style', mode]">
              <span v-if="buttonText">{{ buttonText }}</span>
              <i v-else class="el-icon-plus"/>
            </div>
          </template>
          <slot />
          <div v-if="mode === 'list'" slot="tip" class="j-upload-style-tip-slot"><slot name="tip-center" /></div>
        </template>
      </el-upload>
      <!--<transition-group name="fade" mode="out-in">-->
      <j-file v-for="(src, index) in fileList" :key="src" :src="src" :type="mode" :use-fully="needFully"><i v-if="!readOnly" class="el-icon-delete" @click="handleRemove(index)" /></j-file>
      <div :class="['j-file-style', mode]" v-for="(file, i) in progressList" :key="file.uid">
        <div :class="`j-file-style-${mode}`">
          <el-progress class="j-upload-progress" :type="mode === 'list' ? 'line' : 'circle'" :percentage="parseInt(file.percentage)" />
          <span :class="`j-file-style-${mode}_ctrl`"><i  class="el-icon-delete" title="取消上传" @click="handleAbort(file, i)"/></span>
        </div>
      </div>
      <!--</transition-group>-->
    </div>
    <div class="j-upload-style-tip-slot"><slot name="tip-bottom" /></div>
  </div>
</template>

<script>
    import moment from 'moment'
    import { fls, bucketName, system } from '@/config'
    import oss from "../JTool/oss/oss";
    import JFile from "../JFile/JFile";
    export default {
        name: "JUpload",
        inheritAttrs: false, // $attrs 继承的属性会在组件根容器节点上展示
        components: { JFile },
        props: {
            buttonText: { // 上传占位符显示文字
                type: String,
                default: ''
            },
            mode: { // [list, card, icon]
                type: String,
                default: 'list'
            },
            errorPrompt: { // 是否显示报错
                type: Boolean,
                default: true
            },
            countLimit: { // 默认上传10个文件
                type: Number,
                default: 10
            },
            mimeTypeLimit: { // mimeType数组限制,仅能上传数组中限定的文件类型, 和文件后缀相比mimeType限制交互更好
                type: Array,
                default: () => []
            },
            fileSuffixLimit: {
                type: Array,
                default: () => []
            },
            sizeLimit: { // 上传文件大小限制(MB)
                type: Number,
                default: 0
            },
            readOnly: { // 只读模式下 不可以删除、上传可以文件下载和预览
                type: Boolean,
                default: false
            },
            type: { // 决定了双向绑定时组件返回的数据类型，包含String 和 Array两种模式，存的时候用什么模式，回显的时候必须用相同的模式和数据格式
                type: String,
                default: 'String'
            },
            action: { // 可配置的文件上传接口地址
                type: String,
                default: `${fls}/api/files`
            },
            module: { // 可配置的模块名称，决定了文件上传的path路径模块名，推荐每个模块使用不同的名称，文件服务中存储文件夹更加清晰
                type: String,
                default: 'JUpload'
            },
            value: { // 双向绑定值，包含两种类型
                type: [String, Array]
            },
            needFully: { // 返回全路径
                type: Boolean,
                default: false
            },
            drag: { // 拖拽上传
                type: Boolean,
                default: false
            },
            Separator: { // 返回文本时使用分隔符，只有String模式有效
                type: String,
                default: ','
            }
        },
        data() {
            return {
                progressList: [],
                postData: { // 上传时附带的信息
                    path: '',
                    bucketName
                },
                fileList: []
            }
        },
        watch: {
          value () {
             this.bindData()
          }
        },
        created () {
            this.bindData()
            // 规范化path命名
            this.postData.path = `${system || 'grid'}_${bucketName}/${moment().format('YYYY/MM-DD')}/${this.module}`
        },
        methods: {
            // 代码触发上传选择框
            UploadTrigger () {
                this.$refs.JUploadRef.$el.getElementsByClassName('el-upload__input')[0].click()
            },
            bindData () {
                if (!this.checkDataType()) return (this.fileList = [])
                if (this.type === 'Array') this.fileList = this.value
                else this.fileList = this.value.split(this.Separator)
            },
            updateData () {
                if (this.type === 'Array')  this.$emit('input', this.fileList)
                else this.$emit('input', this.fileList.join(this.Separator))
                this.$emit('change', this.fileList)
            },
            // 检验value值和type类型是否匹配
            checkDataType () {
                let checked = true
                if (!this.value) return false
                if (this.type === 'Array') checked = Array.isArray(this.value)
                else checked = typeof(this.value) === 'string'
                if (!checked) {
                    const error = `解析失败：value: ${this.value}绑定值类型与设定type：${this.type}值类型不匹配`
                    console.warn(error)
                    this.$message && this.$message.warning(error)
                }
                return checked
            },
            srcFormat (generateName) {
                return this.needFully ? oss.getUrlByGenerateName(generateName) : generateName
            },
            handleRemove (i) {
                this.fileList.splice(i, 1)
                this.updateData()
            },
            handleAbort (file, i) {
                this.$refs.JUploadRef.abort(file)
                this.progressList.splice(i, 1)
            },
            handleError (err, file, fileList) {
                const { msg, message } = err
                console.warn(msg || message || '文件上传异常')
                if (this.errorPrompt) this.$message && this.$message.error(msg || message || '文件上传异常')
                this.$emit('upload-error', err, file, fileList)
            },
            handleSuccess (res, file, fileList) {
                this.progressList.splice(this.progressList.findIndex(f => f.uid === file.uid), 1) // 删除进度元素
                if (res.status === 'yes') {
                    const src = this.srcFormat(res.data.generateName)
                    this.fileList.push(src)
                    this.$emit('upload-complete', src)
                    this.updateData()
                } else {
                    const message = res.msg || res.message || '接口异常'
                    console.warn(`文件：${file.name}上传失败，${message}`)
                    if (this.errorPrompt) this.$message && this.$message.error(`文件：${file.name}上传失败，${message}`)
                    return this.$emit('upload-error', res, file, fileList)
                }
            },
            handleExceed (files, fileList) {
                console.warn(`最多上传${this.countLimit}个文件`)
                this.$message && this.$message.error(`最多上传${this.countLimit}个文件`)
                this.$emit('upload-exceed', files, fileList)
            },
            handleProgress (event, file, fileList) {
                this.progressList = fileList
                this.$emit('upload-progress', event, file, fileList)
            },
            handleSuffix (fileName) {
              return fileName.substring(fileName.lastIndexOf('.'))
            },
            handleCheck (file) {
                let mimeType = true
                let size = true
                if ((this.fileSuffixLimit.length > 0 && !this.fileSuffixLimit.includes(this.handleSuffix(file.name))) || (this.mimeTypeLimit.length > 0 && !this.mimeTypeLimit.includes(file.type))) mimeType = false
                if (this.sizeLimit > 0 && (file.size / 1024 / 1024) > this.sizeLimit) size = false
                if (!mimeType) {
                    let limitCollection = [...this.fileSuffixLimit, ...this.mimeTypeLimit]
                    this.$message.error(`上传文件允许格式:${limitCollection.join(',')}`)
                    this.$emit('upload-error', {
                        status: 'no',
                        msg: '文件类型不允许',
                        mimeType: file.type,
                        mimeTypeLimit: limitCollection
                    }, file, this.fileList)
                }
                if (!size) {
                    this.$message.error(`上传文件大小不能超过 ${this.sizeLimit}MB`)
                    this.$emit('upload-error', {
                        status: 'no',
                        msg: '文件大小超出限定',
                        size: (file.size / 1024 / 1024),
                        sizeLimit: this.sizeLimit
                    }, file, this.fileList)
                }
                return mimeType && size
            }
        }
    }
</script>

<style lang="scss">
    .j-upload-layout-wrap {
      .j-upload-style-tip-slot {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(21,24,30,0.3);
        line-height: 20px;
      }
    }
    .j-upload-layout {
        &.list {
          text-align: left;
        }
        &.card, &.icon {
          display: grid;
          grid-template-rows: repeat(auto-fill, 80px);
          grid-template-columns: repeat(auto-fill, 80px);
          grid-gap: 12px;
          .j-file-style {
            margin: 0;
          }
        }
        &.icon {
          grid-template-rows: repeat(auto-fill, 90px);
          grid-template-columns: repeat(auto-fill, 90px);
        }
        .j-upload-style {
            &.j-upload-drag {
              width: 100%;
              .el-upload { width: 100%; }
            }
            .el-upload { text-align: left; display: inline-flex; }
            .j-upload-style-slot {
                &.card {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    > i {
                        font-size: 24px;
                        color: #2CA2F2;
                    }
                    > span {
                        font-size: 14px;
                        color: #2CA2F2;
                    }
                }
                &.icon {
                    width: 90px;
                    height: 90px;
                    min-height: 90px;
                    padding: 0;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;
                    border: 1px dashed #E4E7ED;
                    transition: all .3s linear;
                    &:hover {
                        border-color: #2CA2F2;
                        > i {
                            color: #2CA2F2;
                        }
                        > span {
                            color: #2CA2F2;
                        }
                    }
                    > i, .j-svg-icon-wrap {
                        font-size: 24px;
                        color: #7C8797;
                        transition: color .3s linear;
                    }
                    > span {
                        font-size: 14px;
                        color: #8c939d;
                    }
                }
            }
            &.card, &.icon {
                display: inline-flex;
            }

            .el-upload-dragger {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 100%;
              min-height: 180px;
              height: auto;
              padding: 20px;
              border-radius: 4px;
              box-sizing: border-box;
              border-color: #E5E6EB;
              line-height: 22px;
              &:hover {
                border-color: #286af9;
              }
            }

            .j-upload-style-drag {
              width: 100%;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(21,24,30,0.85);
              box-sizing: border-box;
              text-align: center;
              margin-bottom: 4px;
              &:before {
                display: block;
                content: "";
                height: 48px;
                width: 48px;
                background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEwklEQVRoQ+2YXWwUVRTH/2e2tlVCFFAeS0naWHenXXZmd6ZgUOsDghGVKPUjJj4pRpr4FaMG0FJRMZpojCj46Au1REzwK/LgRyrQne7sdstOGxW1hibG0AiJVlrpzDGzS5ut3XbvzLaBJjuPO///Oed3z7137l3CIn9okdePMsCl7mC5A+UOlDgC5SlU4gCWbJ+XDrS3t0sb7773ZrJpE8DNBNQxaBkABngEwDCBjjkSfXP+3B9HW1paJkqu/GKAkgAsy6r8exzbwHgG4FVCRRGGwbw/wONvRaPRf4Q8c4h8A/T2WRrb+JDB1/ss4jeA23S18TOf/qzNF0A8NfgwHGc/wNWlJM9NMerQlOBuImI/sTwDxJOZ58DY6yfZrB6iA7oSesxPTE8A8ZS1lRidzCz5STa3h9p1NbTba1xhgJ6kFSR2EgBd6TWJiJ6IHMC+VVOavhPRT2qEAeJm5isAG7wE96ol0M+jy6+SW1avHhP1CgHE+wbvgG1/Khq0FB1J0nYtEnxPNIYQgJHMfM+MG0WDlqQjGpKIHyJb+iUaDf5eLFZRANO06ibAPxULtCDviU6xw52VUtU7ilJ/plCOogBGauAJdpy3vRaYW5ROW84nvVvKzkXAOTB2aFF5xtQqDpDMHGTG/T4AXtKUUIfrM5LWi8zseYuckZPofS0SbMsNTu4pChA3M30Awl4AiPBxLBLaOvl1ZWbqTVmHmHGPlziFtEzY26zILxQFSKVS10xw5VqHnYMAXe0hcX91hb0uHA6P5nvS6fSSsYnAcQBNHmIVZACwSVdld1uf2YFj6fTKigsVr4LwIMBeP1ojjhSIrY3cMFQo84nUYK3k2L0Ari0RIq0poYjb4WlTqMccaJbARxh8nY8EFySJN8Qijd/O5e1NnbzFcegogCt85Mi3bHS7MAWQOypwD4ClfgKThO1aZOYuUSiWkco8zg72+cmTN/f3aarclgVwF5mRtEwAET9BCfhAU+VtXryGmTnAwKNePNO0hLSuyGuyAHHz5BaADvsJRoTRkaVVK26vrx/34s/e5s7zCMhnx0FnNDW0MgvQY1qdBL7PSwF5WvdS8iYIp6f7Ayd0pSHh/mYYmRhXUPP091wLxlMiW3mhuggY11S5OteBpDUEFrzTClNKO3U1+EquwwM7AGePsFVMeFpX5ZqLUyjjHl+rxHyiqoUGoG5dDd2UBTBMa4TBK0RLE9MtLAARdmmKvGeyA+7HJSpWmKhq4QDcs1CAHVlVGwdziziReZkIO0VLE9MtHACDPmpWQ9kDZhYgYVk19hj/OL/rYMEAzmLCVnU9/OsUQHYdJAc6mJ1dYqMroCI8ryvy67ldbn7+imFmOyBJm2NK6MvJCqaOEu6FwzCtwyDcJVBeUQkBd2qqnL1HG+bgZoZ9pKhpbsFfkKQH9Ejw83zZtMNcV1dXYFV96DU4/GQphy0iGEOnBta1trbabjI3bm1d8DgzNF8QRF9IgcDTsXDDD//3F7zQJBL9DTakRwDcBqIagMUOeER/Avjk31H72fXrm87mJ+vu7l9WuSTwBoAtYF4+G4i7wzCzu60PS5C+pgAOxdaEjFn1vkbkMjIVvVJeRrUWLKUMcKk7VO5AuQMljsCin0L/AWb/t0CDFmDZAAAAAElFTkSuQmCC");
                background-size: cover;
                margin: 0 auto 8px;
              }
              > span {
                color: #286AF9;
                line-height: 22px;
              }
            }
        }
        .j-file-style-list {
            .j-upload-progress {
                flex: 1;
                min-width: 50px;
            }
        }
        .j-file-style-card {
            .j-upload-progress {
                padding: 5px;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                .el-progress-circle {
                    width: 100%!important;
                    height: 100%!important;
                }
            }
        }
        .j-file-style-icon {
            .j-upload-progress {
                padding: 0 4px;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                .el-progress-circle {
                    width: 100%!important;
                    height: 100%!important;
                }
            }
        }
    }
    .fade-enter-active { transition: opacity .1s; }
    .fade-leave-active { transition: opacity .1s; }
    .fade-enter { opacity: 1 }
    .fade-leave-to { opacity: 0 }
</style>
